/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = Zahlung (Zahlung)
 * 
 * 401130001 = Forderbetrag (Förderbetrag)
 * 
 * 401130002 = Keiner (Keiner)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceMittelabruf {
 Zahlung = 401130000,
 Forderbetrag = 401130001,
 Keiner = 401130002
}

marker([
    "Enum.GlobalEnumsAceMittelabruf.Zahlung",
    "Enum.GlobalEnumsAceMittelabruf.Forderbetrag",
    "Enum.GlobalEnumsAceMittelabruf.Keiner"
]);

export namespace GlobalEnumsAceMittelabruf
{
    class DataSets
    {
        static GlobalEnumsAceMittelabrufDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Zahlung", 401130000, "Zahlung"),
            new EnumValue("Forderbetrag", 401130001, "Förderbetrag"),
            new EnumValue("Keiner", 401130002, "Keiner"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceMittelabrufDataSet;
    }
}
